import { SimpleSearchQueryField } from './simple-search-query-field';
export class BooleanFilter extends SimpleSearchQueryField {
  constructor(searchOptions, withprice) {
    super(searchOptions, BooleanFilter.parse(withprice));
  }
  isDefault() {
    return !this.internalValue;
  }
  getUrlParameterValue() {
    return this.internalValue || null;
  }
  getCondensedValue() {
    return this.internalValue || null;
  }
  get value() {
    return this.internalValue || null;
  }
  static parse(value) {
    return value === true || typeof value === 'string' && value.toLowerCase() === 'true';
  }
}